import React, {  useState, useEffect } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../../../services/back.service';

const SCOPE = 'header:obsComp';

function FormAddObsComp({ id }) {
  const [msgButton, setMsgButton] =useState('Guardar Informacion');
  const [infoObsAdditional, setInfoObsAdditional] = useState({
    obs_components:'',
  });

  const sendInfo = async (event) => {
    event.preventDefault();
    const body = { ...infoObsAdditional, scope: SCOPE };
    const respo = await post('/peritaje/modifyinspection/header/'+id, body);
    if(respo.success){
      setMsgButton('Actualizar')
    }
  };


  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setInfoObsAdditional({ ...infoObsAdditional, [target.name]: value });
    //generalUpdate(target.name, value);
  };

  useEffect(() => {
    const initForm = async () => {
      const respo = await get('/peritaje/infoinspection/'+id, {});
      if(respo.success){
        setInfoObsAdditional({
          obs_components: respo.data.obs_components,
        });
      }
    };
    initForm();
  }, [id]);

  return <Container>
      <Row>
        <Col>
          <Form.Label htmlFor="obs_components">Observaciones Componentes</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="obs_components"
            value={infoObsAdditional.obs_components}
            onChange={(e) => handleForm(e)}
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
          {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  ;
}

export default FormAddObsComp;
